import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface FAQItem {
  question: string;
  answer: string;
}
export const SuperfoodsFAQSection: React.FC = () => {
  const [openItem, setOpenItem] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenItem(openItem === index ? null : index);
  };
  const faqItems: FAQItem[] = [{
    question: 'Mohu kombinovat trénink a zelené potraviny?',
    answer: 'Rozhodně ano. To je právě ta nejsilnější kombinace. Každý z těchto prvků podporuje jinou část těla i mysli – a dohromady tvoří systém, který funguje.'
  }, {
    question: 'Na jak dlouho mi vydrží jeden balíček superpotravin?',
    answer: 'To je individuální, jelikož počet který se bere například chloreli, tak se odvodí od Vaši váhy. Ale samozřejmě, nezačnete hned od začátku brát, plné dávky. Proč? Protože superpotraviny mají detoxikační učinky, a dávky se musí postupně zvedat. Pokud někoho tělo je opravdu zakyselené, tak to může mít i efekt takový, že Vám bude trochu divně od břicha, ale nebojte tenhle pocit je úplně normální, a pokud si tímhle pocitem procházíte, tak víte, že superpotraviny fungují. Po maximálně 3 dnech už by Vám mělo být líp.'
  }, {
    question: 'Jsou produkty vhodné i pro ženy?',
    answer: 'Ano – plány i doplňky jsou vhodné pro ženy i muže.'
  }, {
    question: 'Chci jen tréninkový plán. Musím kupovat i doplňky?',
    answer: 'Nemusíš. Ale doporučuji to, pokud chceš výsledky rychleji, bezpečněji a udržitelně. Trénink je základ. Ale výživa a regenerace dělají tvůj posun ještě větší.'
  }, {
    question: 'Chci spolupracovat s GW– jak to funguje?',
    answer: 'Nejdřív si udělej vlastní zkušenost – objednej si zelené potraviny. Až budeš mít vlastní výsledky, můžeme probrat spolupráci. Tohle není síťovka pro prodejce. Je to o pomoci lidem a budování hodnoty.'
  }, {
    question: 'Proč bych měl začít užívat superpotraviny preventivně, i když momentálně nemám žádné zdravotní problémy?',
    answer: 'Superpotraviny nejen podporují růst svalů, regeneraci a další procesy, které vedou k rychlejšímu progresu, ale zároveň fungují i preventivně. To znamená, že i když teď nemáš žádné zdravotní problémy, tvoje tělo z nich může těžit a dlouhodobě posilovat svou odolnost.\n\nMožná si říkáš, že žádné problémy teď nemáš, ale to neznamená, že tvoje tělo nic nepotřebuje – jen ti zatím neposílá varovné signály. Většina lidí z Green Ways, kteří si prošli změnou, by dala všechno proto, aby mohla začít brát superpotraviny už preventivně, dřív než problémy nastaly.\n\nTo je i důvod, proč jsem začal podnikat s Green Ways – nejen že je to skvělý nástroj pro urychlení progresu v posilovně, ale zároveň funguje jako preventivní potravina pro tělo. Vyživuje a dodává živiny, které jsou nezbytné pro zdravé fungování. Většina mladých lidí neřeší své zdraví, dokud nemají problémy – a právě proto chci dostat superpotraviny mezi co nejvíc mladých lidí, aby se nemocem předcházelo, místo aby se řešily až tehdy, když nastanou.'
  }, {
    question: 'V čem je Green Ways komunita výjimečná?',
    answer: 'Green Ways komunita sdružuje lidi, kteří odmítají jít stejným směrem jako většina společnosti, pokud jde o zdraví.\n\nNechtějí čekat, až se objeví problémy, aby pak spoléhali na léky, které sice vyřeší jeden problém, ale často přinesou jiný.\n\nTahle komunita se rozhodla jít proti proudu – vědomě, přirozeně a s důrazem na dlouhodobé zdraví, ne na rychlé náplasti.\n\nGreen Ways jako firma funguje už více než 25 let a investuje obrovské prostředky do pozemků na těch nejlepších místech pro pěstování nejkvalitnější chlorelly a ječmene na trhu.\n\nNa stránkách najdeš stovky příběhů lidí, kteří sdíleli svou proměnu a popsali, jak jim to změnilo život.\n\nGreen Ways spojuje lidi, kteří věří, že tělo má neuvěřitelnou schopnost uzdravovat se, když mu dáme to, co opravdu potřebuje. A právě tahle víra spolu s kvalitou a výsledky dělá komunitu Green Ways výjimečnou.'
  }];
  return <section className="section section-dark relative py-16 pb-32" id="faq-superfoods" data-id="element-730">
      {/* Elegant top separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500/20 to-transparent" data-id="element-731" />

      {/* Subtle glow effect at top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-green-500/5 blur-3xl pointer-events-none" data-id="element-732" />

      <div className="container mx-auto px-4 section-content" data-id="element-733">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black mb-8 md:mb-12 text-center" data-id="element-734">
          <span className="text-green-500" data-id="element-735">FAQ</span> - Časté otázky
        </motion.h2>

        <div className="max-w-3xl mx-auto" data-id="element-736">
          {faqItems.map((item, index) => <motion.div key={index} className="mb-4 border border-gray-700/30 rounded-lg overflow-hidden luxury-card" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-737">
              <button className="flex justify-between items-center w-full p-4 md:p-5 text-left bg-gray-900/40 hover:bg-gray-800/60 transition-colors backdrop-blur-sm" onClick={() => toggleItem(index)} data-id="element-738">
                <span className="text-sm md:text-lg font-medium pr-4" data-id="element-739">
                  {item.question}
                </span>
                {openItem === index ? <ChevronUpIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-740" /> : <ChevronDownIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-741" />}
              </button>
              <motion.div initial={false} animate={{
            height: openItem === index ? 'auto' : 0,
            opacity: openItem === index ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-742">
                {openItem === index && <div className="p-4 md:p-5 bg-gray-800/40 border-t border-gray-700/30 backdrop-blur-sm" data-id="element-743">
                    <p className="whitespace-pre-line text-xs md:text-base text-gray-300" data-id="element-744">
                      {item.answer}
                    </p>
                  </div>}
              </motion.div>
            </motion.div>)}
        </div>
      </div>

      {/* Elegant bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500/20 to-transparent" data-id="element-745" />

      {/* Subtle glow effect at bottom */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1/2 h-32 bg-green-500/5 blur-3xl pointer-events-none" data-id="element-746" />
    </section>;
};